// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { IsNotEmpty, IsCurrency, IsPositive } from "class-validator";

// Models
import { FinancialCommitmentDTO } from "Globals/Models/DTO/FinancialCommitmentDTO";

export class FinancialCommitmentModel extends ModelBase<FinancialCommitmentModel, FinancialCommitmentDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public incomeDetailId: string | null = null;

    @IsNotEmpty({ message: "Name of acount holder is required" })
    @MobX.observable
    public purpose: string | null = null;

    @IsNotEmpty({ message: "Balance is required" })
    @MobX.observable
    public amount: number | null = null;

    @IsNotEmpty({ message: "Payment end date is required" })
    @MobX.observable
    public paymentEndDate: Date | null = new Date();

    @MobX.observable public createdDate: Date | null = null;

    @MobX.observable public sameForApplicantTwo: boolean = false;

    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: FinancialCommitmentDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.incomeDetailId = model.incomeDetailId;
            this.purpose = model.purpose;
            this.amount = model.amount;
            this.paymentEndDate = model.paymentEndDate;
            this.createdDate = model.createdDate;
            this.sameForApplicantTwo = model.sameForApplicantTwo;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): FinancialCommitmentDTO => {
        let model: FinancialCommitmentDTO = {
            id: this.id,
            incomeDetailId: this.incomeDetailId,
            purpose: this.purpose,
            amount: this.amount,
            paymentEndDate: this.paymentEndDate,
            createdDate: this.createdDate,
            sameForApplicantTwo: this.sameForApplicantTwo,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = null;
        this.incomeDetailId = null;
        this.purpose = "";
        this.amount = 0;
        this.paymentEndDate = new Date();
        this.createdDate = null;
        this.sameForApplicantTwo = false;
        this.isDeleted = false;
    };
}
